/**
 * Created by neo on 16.10.21.
 */
import { ActivityLogAnalyticsAggregationResult, createActivityLogAnalyticsAggregationResult } from './ActivityLogAnalyticsAggregationResult';
import { HttpBackend } from '../../Services/Http/HttpBackend';

export type AggregateType = 'sum' | 'average' | 'min' | 'max';

export type AggregateWindow = 'hour' | 'day' | 'week' | 'month' | 'year' | 'none';

export type ActivityLogAnalyticsQueryRequest = Record<string, any> & {
  type?: string;
  startDateTime?: Date;
  endDateTime?: Date;
  sourceId?: string[];
  sourceType?: string;
  aggregate?: AggregateType;
  window?: AggregateWindow;
};

// Static API methods for analytics
export const ActivityAnalyticsApi = {
  /**
   * To get a 'series' of data use the window function and set it accordingly
   */
  find(request?: ActivityLogAnalyticsQueryRequest): Promise<ActivityLogAnalyticsAggregationResult[]> {
    const finalRequest = Object.assign({ window: 'day' }, request ?? {});
    return HttpBackend.get(`/activity/analytics`, finalRequest).then((result) =>
      (result ?? []).map((r: any) => createActivityLogAnalyticsAggregationResult(r)),
    );
  },

  summary(request?: ActivityLogAnalyticsQueryRequest): Promise<ActivityLogAnalyticsAggregationResult> {
    const finalRequest = Object.assign({}, request ?? {});
    if (request) {
      delete finalRequest.window;
    }
    return HttpBackend.get(`/activity/analytics`, finalRequest).then(
      (result) =>
        (result ?? []).map((r: any) => createActivityLogAnalyticsAggregationResult(r))[0] ??
        createActivityLogAnalyticsAggregationResult(),
    );
  },
};

export const ActivityAnalytics = ActivityAnalyticsApi;
